
const ApiGuards = {
  preSendGuard (url, ctx, resolve, reject) {
  },
  errorGuard (XMLHttpRequest, textStatus, err, resolve, reject) {
  },
  successGuard (ctx, textStatus, XMLHttpRequest, resolve, reject) {
  }
}
export default ApiGuards
